import { Link } from "react-router-dom";
import LegalPageLayout from "@/components/LegalPageLayout";
import {
  COMPANY_ADDRESS_FULL,
  COMPANY_BRAND_NAME,
  COMPANY_CIF,
  COMPANY_CONTACT_EMAIL,
  COMPANY_LEGAL_NAME,
} from "@/lib/company";

const TerminosCondiciones = () => {
  return (
    <LegalPageLayout title="Términos y Condiciones">
            <p className="text-gray-600 mb-6">
              Última actualización: {new Date().toLocaleDateString("es-ES")}
            </p>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">1. Aceptación de los Términos</h2>
              <p className="text-gray-700 mb-4">
                Al acceder y utilizar la plataforma Taxby, aceptas estar sujeto a estos términos y condiciones de uso. 
                Si no estás de acuerdo con alguna parte de estos términos, no debes utilizar nuestros servicios.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">2. Titular del Servicio</h2>
              <p className="text-gray-700 mb-4">
                El servicio {COMPANY_BRAND_NAME} es operado por {COMPANY_LEGAL_NAME}, con CIF {COMPANY_CIF} y
                domicilio social en {COMPANY_ADDRESS_FULL}.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">3. Descripción del Servicio</h2>
              <p className="text-gray-700 mb-4">
                Taxby es una plataforma de gestión fiscal y contable diseñada específicamente para autónomos en régimen 
                de estimación directa. Nuestros servicios incluyen:
              </p>
              <ul className="list-disc pl-6 text-gray-700 mb-4">
                <li>Gestión contable automatizada</li>
                <li>Presentación de modelos fiscales</li>
                <li>Asesoramiento fiscal profesional</li>
                <li>Integración con plataformas de venta online</li>
                <li>Herramientas de análisis financiero</li>
              </ul>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">4. Registro y Cuenta de Usuario</h2>
              <p className="text-gray-700 mb-4">
                Para utilizar nuestros servicios, debes registrarte y crear una cuenta. Te comprometes a:
              </p>
              <ul className="list-disc pl-6 text-gray-700 mb-4">
                <li>Proporcionar información veraz y actualizada</li>
                <li>Mantener la confidencialidad de tus credenciales</li>
                <li>Notificar inmediatamente cualquier uso no autorizado</li>
                <li>Ser responsable de todas las actividades realizadas con tu cuenta</li>
              </ul>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">5. Uso Aceptable</h2>
              <p className="text-gray-700 mb-4">
                Te comprometes a utilizar nuestros servicios únicamente para fines legales y de acuerdo con estos términos. 
                Está prohibido:
              </p>
              <ul className="list-disc pl-6 text-gray-700 mb-4">
                <li>Usar los servicios para actividades ilegales</li>
                <li>Intentar acceder no autorizado a nuestros sistemas</li>
                <li>Interferir con el funcionamiento de la plataforma</li>
                <li>Transmitir virus o código malicioso</li>
                <li>Violar derechos de propiedad intelectual</li>
              </ul>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">6. Privacidad y Protección de Datos</h2>
              <p className="text-gray-700 mb-4">
                El tratamiento de tus datos personales se rige por nuestra{" "}
                <Link to="/politica-privacidad" className="text-taxby-purple hover:text-taxby-violet hover:underline">
                  Política de Privacidad
                </Link>
                , que forma parte integrante de estos términos. Al utilizar nuestros servicios, consientes el
                tratamiento de tus datos de acuerdo con dicha política.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">7. Propiedad Intelectual</h2>
              <p className="text-gray-700 mb-4">
                Todos los derechos de propiedad intelectual sobre la plataforma {COMPANY_BRAND_NAME}, incluyendo pero no limitado a
                software, diseño, contenido y marcas comerciales, pertenecen a {COMPANY_LEGAL_NAME} o a sus licenciantes.
                No se otorga ninguna licencia implícita para usar estos derechos.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">8. Limitación de Responsabilidad</h2>
              <p className="text-gray-700 mb-4">
                {COMPANY_LEGAL_NAME} se esfuerza por proporcionar servicios precisos y confiables, pero no garantiza que la información
                sea completamente libre de errores. En ningún caso seremos responsables por daños indirectos, 
                incidentales o consecuentes.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">9. Modificaciones</h2>
              <p className="text-gray-700 mb-4">
                Nos reservamos el derecho de modificar estos términos en cualquier momento. Los cambios entrarán 
                en vigor inmediatamente después de su publicación. Te recomendamos revisar periódicamente estos términos.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">10. Terminación</h2>
              <p className="text-gray-700 mb-4">
                Podemos suspender o terminar tu acceso a nuestros servicios en cualquier momento, con o sin causa, 
                con o sin previo aviso. También puedes cancelar tu cuenta en cualquier momento.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">11. Ley Aplicable</h2>
              <p className="text-gray-700 mb-4">
                Estos términos se rigen por las leyes españolas. Cualquier disputa será resuelta en los tribunales 
                competentes de España.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">12. Contacto</h2>
              <p className="text-gray-700 mb-4">
                Si tienes alguna pregunta sobre estos términos, puedes contactarnos a través de:
              </p>
              <ul className="list-disc pl-6 text-gray-700 mb-4">
                <li>
                  Email:{" "}
                  <a href={`mailto:${COMPANY_CONTACT_EMAIL}`} className="text-taxby-purple hover:text-taxby-violet hover:underline">
                    {COMPANY_CONTACT_EMAIL}
                  </a>
                </li>
                <li>Dirección: {COMPANY_ADDRESS_FULL}</li>
                <li>CIF: {COMPANY_CIF}</li>
              </ul>
            </section>
    </LegalPageLayout>
  );
};

export default TerminosCondiciones; 